import { NotificationAlertOverride } from ".";
import { NotificationHandleType } from "../../Notifications";
import {
  createRequirementAction,
  createRequirementChildren,
  createRequirementTitle
} from "./helper";

export const RequirementsRejectedPayee: NotificationAlertOverride = (
  notification,
  history
) => {
  return {
    theme: "error",
    icon: "alert-circle",
    title: createRequirementTitle(
      notification,
      NotificationHandleType.RequirementsRejectedPayee
    ),
    children: createRequirementChildren(
      notification,
      NotificationHandleType.RequirementsRejectedPayee
    ),
    action: createRequirementAction(notification, history)
  };
};
